import styles from './whatsNearby.module.css';
import globalStyles from '../result.module.css';


const Nearby = ({data}) => {
    if(!data) return null;
    return <>
        
          <div className={styles.AddressContain}>
            <div className={globalStyles.mediumText}>Nearby Places</div>
          </div>
          <div className={styles.WhatsNearByWrapper}>
            {Object.keys(data).map((n) => {
                let d = Object.keys(data[n]);

                let placeData = d.map((key) => {
                  return data[n][key];
                })
                if(d.length == 0) return null;
                return <div key={n}>
                        {placeData.sort((a,b) => {
                          return (b.rating * b.ratingTotal) - (a.rating * a.ratingTotal);
                        }).slice(0,3).map((place) => {
                          return <div key={place.name} className={styles.WhatsNearByPlace}>
                                  <div className={styles.IconContain} style={{backgroundColor: place.iconBackgroundColor}}>
                                    <img src={place.icon} alt={n}></img>
                                  </div>
                                  
                                  <div className="mediumText">{place.name}</div>
                                </div>
                        })}
                    </div>
            })}
          </div>
          </>
};

export default Nearby;
